const translations: Record<string, string> = {
  "ak_ueex_mwh_deals": "{{mwh}} МВт·год | {{n}} угод",
  "ak_ueex_mwh": "{{mwh}} МВт·год",
  "ak_ueex_uah": "{{n}} грн",
  "ak_ueex_mwh_2": "{{n}} МВт·год",
  "ak_ueex_uah_2": "грн",
  "ak_ueex_uah_mwh": "грн/МВт·год",
  "ak_ueex_mwh_3": "МВт·год",
  "ak_ueex_lots": "лотів",
  "ak_ueex_deals": "угод",
  "ak_ueex_block": "Блочна",
  "ak_ueex_base_vs_block": "BASE vs Блочна",
  "ak_ueex_offered_mwh": "Offered МВт·год",
  "ak_ueex_uah_excl_vat": "грн без ПДВ",
  "ak_ueex_mwh_deals_2": "{{mwh}} МВт·год · {{n}} угод",
};

export default translations;
